module.exports = __webpack_public_path__ + "img/icon_j5.d0dd34d.png";